var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "role"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('b', [_vm._v("Mark Shipment Damage")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "AWB Numbers :<span style='color: red'>*</span> ",
      "description": ""
    }
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-book'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "awbnumber",
      "name": "awbnumber",
      "type": "text"
    },
    model: {
      value: (_vm.awbnumber),
      callback: function($$v) {
        _vm.awbnumber = $$v
      },
      expression: "awbnumber"
    }
  }), _vm._v(" "), _c('b-input-group-button', {
    slot: "right"
  }, [_c('b-button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        _vm.searchAwbNumber()
      }
    }
  }, [_vm._v(" Go "), _c('i', {
    staticClass: "fa fa-angle-double-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Current Region Name :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-university'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "id": "hubzonename",
      "name": "hubzonename",
      "type": "text"
    },
    model: {
      value: (_vm.hubzonename),
      callback: function($$v) {
        _vm.hubzonename = $$v
      },
      expression: "hubzonename"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Origin HUB/SVC name :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-map-marker'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "id": "OriginHub",
      "name": "awbnumber",
      "type": "text"
    },
    model: {
      value: (_vm.hubOrigin),
      callback: function($$v) {
        _vm.hubOrigin = $$v
      },
      expression: "hubOrigin"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Current HUB/SVC name :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-map-marker'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "id": "Currenthub",
      "name": "awbnumber",
      "type": "text"
    },
    model: {
      value: (_vm.currentHubName),
      callback: function($$v) {
        _vm.currentHubName = $$v
      },
      expression: "currentHubName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Destination HUB/SVC name :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-map-marker'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "id": "Destinationhub",
      "name": "awbnumber",
      "type": "text"
    },
    model: {
      value: (_vm.destinationHubName),
      callback: function($$v) {
        _vm.destinationHubName = $$v
      },
      expression: "destinationHubName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Last Service [Coloder/Vender] :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-book'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "id": "lastService",
      "name": "lastService",
      "type": "text"
    },
    model: {
      value: (_vm.lastService),
      callback: function($$v) {
        _vm.lastService = $$v
      },
      expression: "lastService"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Bag Condition :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-suitcase'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "id": "bagCondition",
      "name": "bagCondition",
      "type": "text"
    },
    model: {
      value: (_vm.bagCondition),
      callback: function($$v) {
        _vm.bagCondition = $$v
      },
      expression: "bagCondition"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" DEPS Bag Condition :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-suitcase'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "DEPSbagCondition",
      "options": _vm.vStatusList,
      "placeholder": "Select",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.DEPSbagCondition),
      callback: function($$v) {
        _vm.DEPSbagCondition = $$v
      },
      expression: "DEPSbagCondition"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" OctroiMRP :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-book'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "id": "OctroiMRP",
      "name": "OctroiMRP",
      "type": "text"
    },
    model: {
      value: (_vm.OctroiMRP),
      callback: function($$v) {
        _vm.OctroiMRP = $$v
      },
      expression: "OctroiMRP"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Client Name :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-book'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "id": "Clientname",
      "name": "Clientname",
      "type": "text"
    },
    model: {
      value: (_vm.Clientname),
      callback: function($$v) {
        _vm.Clientname = $$v
      },
      expression: "Clientname"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Product Description :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-book'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "id": "productDescription",
      "name": "productDescription",
      "type": "text"
    },
    model: {
      value: (_vm.productDescription),
      callback: function($$v) {
        _vm.productDescription = $$v
      },
      expression: "productDescription"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" STD Reason :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-book'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "STDreason",
      "options": _vm.StatusList,
      "placeholder": "Select",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.STDreason),
      callback: function($$v) {
        _vm.STDreason = $$v
      },
      expression: "STDreason"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Upload 3 Images :<span style='color: red'>*</span> ",
      "description": "Allowed image file types: gif, jpg, jpeg, png (Maximum Size :600 KB)",
      "label-cols": 3
    }
  }, [_c('b-input-group', [_c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('b-input-group-button', {
    slot: "right"
  }, [_c('b-button', {
    staticClass: "btn btn-sm btn-info",
    on: {
      "click": _vm.uploadFile
    }
  }, [_vm._v("Upload")])], 1)], 1), _vm._v(" "), (_vm.isUploading) ? _c('vue-element-loading', {
    attrs: {
      "active": true,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.imagesarr.length != 0) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("File Name")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("View Images")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.imagesarr), function(x, index) {
    return _c('tr', [_c('th', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(x.file))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "scope": "row"
      }
    }, [_c('b-link', {
      on: {
        "click": function($event) {
          _vm.downloadImage(x.imgPath)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('b-link', {
      attrs: {
        "href": x.imgPath
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('b-link', {
      on: {
        "click": function($event) {
          _vm.deleteImage(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)])
  }))]) : _vm._e(), _c('br')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Description :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "name": "description",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.updatedata()
      }
    }
  }, [_vm._v(" Save "), _c('i', {
    staticClass: "fa fa-floppy-o"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_vm._v(" Reset "), _c('i', {
    staticClass: "fa fa-refresh"
  })])])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "imgPopUp",
      "title": "BootstrapVue"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('b-card', [_c('span', {
    staticClass: "download-btn"
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.imgData,
      "download": ""
    }
  }, [_vm._v("Download")])]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.closeImage()
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imgData,
      "alt": "loading..."
    }
  })])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54fe3efc","hasScoped":true}!./src/views/components/AddExcutive/AddExecutive.component.html
// module id = 680
// module chunks = 1